import { Button, Stack, Typography } from "@mui/material";
import { useDialog } from "../contexts/DialogContext";

export function useError() {
  const dialog = useDialog();
  return ({ title, message }: { title?: string; message: string; }) =>
    dialog(() => (
      <div>
        <Stack>
          <Typography>{title ?? "Error"}</Typography>
          <Typography>{message}</Typography>
        </Stack>
        <Stack>
          <Button variant="contained">Ok</Button>
        </Stack>
      </div>
    ));
}
